import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Avatar } from '@/src/elements/avatar'
import { Placeholder } from '@/src/elements/placeholder'
import { Typography } from '@/src/elements/text/Typography'
import { getAvatarUrl } from '@/src/general/utils/getAvatarUrl'

import type { INTENTION_TYPE } from '../../../models/Intention.enums'
import type { TTypeIntention } from '../../../models/Intention.types'

type TIntentionContentProps = {
  intention?: TTypeIntention<INTENTION_TYPE.INTENTION>
}

export const IntentionContent = ({ intention }: TIntentionContentProps): ReactNode => (
  <View className="flex flex-row gap-3 pb-6">
    <Avatar src={getAvatarUrl(intention?.user?.avatar)} size="sm" />
    {intention ? (
      <Typography colors="primary" contrast="high" className="max-w-72">
        {intention.content}
      </Typography>
    ) : (
      <Placeholder className="h-4 w-40" />
    )}
  </View>
)
